import { SiteSettings } from "@made-people/blueprint-site-settings";
import { SitesProviderSite } from "@made-people/grease-sites";
import {
  useGearsConfigurationVariable,
  useGearsServiceUrl,
} from "@made-people/gears-configuration";
import { BffClient } from "@made-people/gears-bff-client";
import { useRouteLoaderData } from "@remix-run/react";
import { gearsLoader, gearsRootLoader } from "@made-people/gears-remix";
import { useHref } from "@made-people/grease-link";
import { Cross } from "../../assets/icons/Cross";

export const MmSiteSettings = () => {
  const rootLoaderData = useRouteLoaderData<typeof gearsRootLoader>("root");
  const pageLoaderData = useRouteLoaderData<typeof gearsLoader>(
    "project-router-wildcard",
  );

  const bffUrl = useGearsServiceUrl("bff");
  const tenantId = useGearsConfigurationVariable("tenantId");
  const href = useHref();

  if (!pageLoaderData?.pageResponse?.frontendContext) {
    return null;
  }

  if (!rootLoaderData) {
    return null;
  }

  const bffClient = new BffClient({ baseUrl: bffUrl, tenantId });
  const frontendContext = pageLoaderData.pageResponse.frontendContext;

  return (
    <SiteSettings
      as="drawer"
      mode={"sites"}
      drawer={{
        header: {
          closeIcon: <Cross className="w-3 h-3" />,
        },
      }}
      form={{
        buttons: {
          close: {
            variants: {
              style: "outline",
              width: "full",
            },
          },
        },
        languageSelector: {
          isEnabled: false,
        },
        onApply: async (
          currentSite: SitesProviderSite,
          countryCode: string,
          languageCode: string,
        ) => {
          const countriesAndLanguages =
            rootLoaderData?.settingsAndContentResponse.countriesAndLanguages;

          if (!countriesAndLanguages) {
            return;
          }

          const { countries, languages } = countriesAndLanguages;

          const newCountry = countries.find(
            (country) => country.countryCode === countryCode,
          );
          const newLanguage = languages.find(
            (lang) => lang.languageCode === languageCode,
          );

          if (
            newCountry?.countryCode &&
            newLanguage?.languageCode &&
            frontendContext
          ) {
            const languageCountryRedirectData = {
              fullSlug: window.location.pathname,
              targetFrontendContext: {
                market: newCountry.marketId,
                pricelist: frontendContext.pricelist,
                currencyCode: currentSite.currencyCode,
                country: newCountry.countryCode,
                language: newLanguage.languageCode,
                siteSlug: frontendContext.siteSlug,
                baseUrl: frontendContext.baseUrl,
                currency: frontendContext.currency,
              },
            };

            const response = await bffClient.findAlternateLinkForSlug(
              languageCountryRedirectData,
            );

            if (typeof response?.frontendContext?.siteSlug === "string") {
              window.location.href = href(
                `/${response.frontendContext.siteSlug}${response.alternateSlug}?countryCode=${newCountry.countryCode}`,
              );
            }
          }
        },
      }}
    />
  );
};
